var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormatSize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10V19C6 19.5439 6.45614 20 7 20C7.54386 20 8 19.5439 8 19V10C8 9.45614 7.54386 9 7 9C6.45614 9 6 9.45614 6 10ZM4 11H10C10.5439 11 11 10.5439 11 10C11 9.45614 10.5439 9 10 9H4C3.45614 9 3 9.45614 3 10C3 10.5439 3.45614 11 4 11ZM14 5V19C14 19.5439 14.4561 20 15 20C15.5439 20 16 19.5439 16 19V5C16 4.45614 15.5439 4 15 4C14.4561 4 14 4.45614 14 5ZM10 6H20C20.5439 6 21 5.54386 21 5C21 4.45614 20.5439 4 20 4H10C9.45614 4 9 4.45614 9 5C9 5.54386 9.45614 6 10 6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatSize);
export default __webpack_public_path__ + "static/media/format_size.46ab6216.svg";
export { ForwardRef as ReactComponent };